import React from 'react'
import styles from './Footer.module.css'
import FabButton from '../Fab/Fab'
import useAuthUser from '../../hooks/useAuthUser'

const Footer = () => {
    const authData = useAuthUser()

    return (
        <footer>
            <div className={styles.footerText}>
            ©2022 Wholesale USA
            </div>
            {authData && (
            <FabButton />
            )}
        </footer>
    )
}

export default Footer
